// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about","866":"partners","982":"product-detail","983":"products"}[chunkId] + "." + {"353":"2bc645d4","594":"7fbe006a","866":"9e57ef84","982":"1e44bef5","983":"c4c412b2"}[chunkId] + ".js";
};